import BossModel from "@/models/BossModel";
import Traveller from "@/models/Dossier/Traveller/Traveller";
import ProposalProductAlternativeDossierTraveller
    from "@/models/Proposal/Product/Alternative/ProposalProductAlternativeDossierTraveller";
import Region from "@/models/Region/Region";
import Country from "@/models/Country/Country";
import Product from "@/models/Proposal/Product/Product";

export default class Alternative extends BossModel {

    static apiUrl = 'proposal/product/alternative';

    static entity = 'proposalProductAlternatives';

    static fields() {
        return {
            id: this.number(null).nullable(),
            region_id: this.number(null).nullable(),
            country_id: this.number(null).nullable(),
            travellers: this.belongsToMany(Traveller, ProposalProductAlternativeDossierTraveller, 'proposal_product_alternative_id', 'dossier_traveller_id'),
            country: this.belongsTo(Country, 'country_id'),
            region: this.belongsTo(Region, 'region_id'),
            product: this.hasOne(Product, 'proposal_product_alternative_id'),
        }
    }
}
